import { AppendReason, MRealObject, RemoveReason, StringPropertyTextBlock, StringRealProperty, StringVirtualProperty, ViewUpdate, VObjectInListWithParent } from "@1oo4/miv";
import { VContentWithTextEdit } from "./contents";
import { MArticle, MChapter, MSection } from "../../shared/model/mdoc";

export abstract class VRef extends VObjectInListWithParent<VContentWithTextEdit> {
    private readonly view: HTMLDivElement;
    readonly panel: HTMLDivElement;
    private readonly tbIndex: HTMLSpanElement;

    constructor(m: MRealObject, index: StringVirtualProperty, name: StringRealProperty, parent: VContentWithTextEdit, panel: HTMLDivElement) {
        super(m, parent);
        this.panel = panel;

        const template = document.getElementById("tpl_edit_ref") as HTMLTemplateElement
        this.view = (template.content.cloneNode(true) as DocumentFragment).children[0] as HTMLDivElement;

        this.tbIndex = this.view.querySelector(".edit_ref_index") as HTMLSpanElement;
        const tb_fullindex = new StringPropertyTextBlock(this.view.querySelector(".edit_ref_fullindex") as HTMLSpanElement);
        tb_fullindex.Setup(index, this);
        const tb_name = new StringPropertyTextBlock(this.view.querySelector(".edit_ref_name") as HTMLSpanElement);
        tb_name.Setup(name, this);
    }

    protected IndexChanged(vu: ViewUpdate): void {
        this.tbIndex.textContent = "(" + (this.IndexInGUI + 1) + ") →";
    }

    protected AppendToGUI(ar: AppendReason, vu: ViewUpdate): void {
        this.panel.appendChild(this.view);
    }
    protected InsertIntoGUI(index: number, vu: ViewUpdate): void {
        this.panel.insertBefore(this.view, this.panel.children[index]);
    }
    protected RemoveFromGUI(rr: RemoveReason, vu: ViewUpdate): void {
        this.panel.removeChild(this.view);
    }
}

export class VRefChapter extends VRef {
    constructor(m: MChapter, parent: VContentWithTextEdit) {
        super(m, m.FullIndex, m.Name, parent, parent.chaptersPanel);
    }
}

export class VRefArticle extends VRef {
    constructor(m: MArticle, parent: VContentWithTextEdit) {
        super(m, m.FullIndex, m.Name, parent, parent.articlesPanel);
    }
}

export class VRefSection extends VRef {
    constructor(m: MSection, parent: VContentWithTextEdit) {
        super(m, m.FullIndex, m.Name, parent, parent.sectionsPanel);
    }
}